/*
 * File: ui-block-autofill.ts
 * File Created: 2024-09-06 05:43:28
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-16 08:46:29
 * Modified By: Val Liu
 * -----
 */

import { ObjectHelper } from "@root/core/utilities";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "../core";
import { uiHidden } from "../ui-hidden";

// @uiVisible - show the cell or form element.
// true | false | inherit

@UITag.set()
export class uiVisible extends uiHidden {
    parse(input: IUITagInput): IUITagResult | null {
        let rule: boolean | string = (this.parseRule(input) as any) ?? true;

        if (rule === "inherit") return null;

        return {
            styles: {
                display: rule === false ? "none" : null,
            },
        };
    }
}
